import { Text, Title } from "@mantine/core";
import { SiteName } from "../../utils/enums";
import { AnchorLink } from "../AnchorLink/AnchorLink";
import { PublicLayout } from "../Layout/PublicLayout";

declare const SITE_NAME: SiteName;

function Imprint() {
  return (
    <PublicLayout>
      <div style={{ maxWidth: "800px", margin: "0 auto", padding: "2rem" }}>
        {SITE_NAME === SiteName.Smarendo && <SmarendoImprint />}
        {SITE_NAME === SiteName.Alva && <AlvaImprint />}
        {SITE_NAME === SiteName.Wavelr && <WavelrImprint />}
        {SITE_NAME === SiteName.Optinode && <OptinodeImprint />}
      </div>
    </PublicLayout>
  );
}

function SmarendoImprint() {
  return (
    <>
      <Title order={2}>Impressum</Title>
      <Text>
        Rödl IT-Consulting GmbH
        <br />
        Äußere Sulzbacher Straße&nbsp;100
        <br />
        90491&nbsp;Nürnberg
        <br />
        Tel.: +49&nbsp;911&nbsp;91&nbsp;93&nbsp;0
        <br />
        Fax: +49&nbsp;911&nbsp;91&nbsp;93&nbsp;1900
        <br />
        E-Mail:{" "}
        <AnchorLink href="mailto:info@roedl.de" target="_self">
          info@roedl.de
        </AnchorLink>
      </Text>

      <Text mt="md">
        Geschäftsführer:
        <br />
        Prof.&nbsp;Dr.&nbsp;Christian Rödl
        <br />
        Heiko Pech
      </Text>

      <Text mt="md">
        Handelsregister:
        <br />
        Amtsgericht Nürnberg, HRB&nbsp;17126
      </Text>

      <Text mt="md">
        Umsatzsteuer-ID:
        <br />
        DE292688673
      </Text>
    </>
  );
}

function AlvaImprint() {
  return (
    <>
      <Title order={2}>Impressum</Title>
      <Text>
        Alva Energie GmbH
        <br />
        Ackerstr. 29
        <br />
        c/o Emil Group GmbH
        <br />
        10115 Berlin
        <br />
        Deutschland
        <br />
        E-Mail:{" "}
        <AnchorLink href="mailto:info@alva-energie.de" target="_self">
          info@alva-energie.de
        </AnchorLink>
      </Text>

      <Text mt="md">
        Geschäftsführer:
        <br />
        Cecil von Croÿ
      </Text>

      <Text mt="md">
        Handelsregister:
        <br />
        14057 Charlottenburg (Berlin), HRB 254579 B
      </Text>
    </>
  );
}

function WavelrImprint() {
  return (
    <>
      <Title order={2}>Impressum</Title>

      <Text mt="md">Angaben gemäß § 5 TMG</Text>

      <Text mt="md">
        Wavelr GmbH
        <br />
        Industriestraße 170
        <br />
        50999 Köln
      </Text>

      <Text mt="md">Vertreten durch Geschäftsführer: Roman Rittmann</Text>

      <Text mt="md">
        Kontakt: Email:{" "}
        <AnchorLink href="mailto:admin@wavelr.com" target="_self">
          admin@wavelr.com
        </AnchorLink>
      </Text>

      <Text mt="md">
        Eintragung im Registergericht: Amtsgericht Köln
        <br />
        Registernummer: HRB 111278 B
      </Text>

      <Text mt="md">
        Haftung für Inhalte: Die Inhalte unserer Seiten wurden mit größter
        Sorgfalt erstellt. Für die Richtigkeit, Vollständigkeit und Aktualität
        der Inhalte können wir jedoch keine Gewähr übernehmen. Als
        Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf
        diesen Seiten nach den allgemeinen Gesetzen verantwortlich. Nach §§ 8
        bis 10 TMG sind wir als Diensteanbieter jedoch nicht verpflichtet,
        übermittelte oder gespeicherte fremde Informationen zu überwachen oder
        nach Umständen zu forschen, die auf eine rechtswidrige Tätigkeit
        hinweisen.
      </Text>

      <Text mt="md">
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
        Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen. Haftung für Links: Unser Angebot enthält Links zu externen
        Webseiten Dritter, auf deren Inhalte wir keinen Einfluss haben. Deshalb
        können wir für diese fremden Inhalte auch keine Gewähr übernehmen.
      </Text>

      <Text mt="md">
        Für die Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
        oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten wurden
        zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft.
        Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht
        erkennbar. Eine permanente inhaltliche Kontrolle der verlinkten Seiten
        ist jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
        zumutbar.
      </Text>

      <Text mt="md">
        Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Links
        umgehend entfernen. Urheberrecht: Die durch die Seitenbetreiber
        erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen
        Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede
        Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
        schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
      </Text>

      <Text mt="md">
        Downloads und Kopien dieser Seite sind nur für den privaten, nicht
        kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite
        nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter
        beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet.
        Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
        bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
        Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
      </Text>
    </>
  );
}

function OptinodeImprint() {
  return (
    <>
      <Title order={2}>Impressum</Title>

      <Text mt="md">Die Angaben erfolgen gem. §&nbsp;5&nbsp;TMG.</Text>

      <Text mt="md">
        node.energy GmbH
        <br />
        c/o GreenTech Hub
        <br />
        Carl-von-Noorden Platz&nbsp;5
        <br />
        60596&nbsp;Frankfurt am Main
      </Text>

      <Text mt="md">
        Fon: +49&nbsp;69&nbsp;999&nbsp;99&nbsp;39&nbsp;80
        <br />
        Fax: +49&nbsp;69&nbsp;999&nbsp;99&nbsp;39&nbsp;81
        <br />
        Mail:{" "}
        <AnchorLink href="mailto:info@node.energy" target="_self">
          info@node.energy
        </AnchorLink>
      </Text>

      <Text mt="md">
        Registergericht: Handelsregister&nbsp;B des Amtsgericht Frankfurt
        <br />
        Registernummer: HRB&nbsp;108778
        <br />
        Umsatzsteuer ID: DE&nbsp;3085&nbsp;15676
      </Text>

      <Text mt="md">
        vertreten durch die Geschäftsführer Matthias Karger und Michael
        Blichmann.
      </Text>

      <Text mt="md">
        Verantwortlich für den Inhalt nach §&nbsp;55&nbsp;Abs.&nbsp;2&nbsp;RStV:
        <br />
        Matthias Karger
      </Text>

      <Title mt="lg" order={4}>
        Haftungsausschluss (Disclaimer)
      </Title>

      <Title mt="md" order={5}>
        Haftung für Inhalte
      </Title>

      <Text>
        Als Diensteanbieter sind wir gemäß §&nbsp;7&nbsp;Abs.&nbsp;1&nbsp;TMG
        für eigene Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
        verantwortlich. Nach §§&nbsp;8&nbsp;bis&nbsp;10&nbsp;TMG sind wir als
        Diensteanbieter jedoch nicht verpflichtet, übermittelte oder
        gespeicherte fremde Informationen zu überwachen oder nach Umständen zu
        forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
        Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
        Informationen nach den allgemeinen Gesetzen bleiben hiervon unberührt.
        Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt der
        Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von
        entsprechenden Rechtsverletzungen werden wir diese Inhalte umgehend
        entfernen.
      </Text>

      <Title mt="md" order={5}>
        Haftung für Links
      </Title>

      <Text>
        Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren
        Inhalte wir keinen Einfluss haben. Deshalb können wir für diese fremden
        Inhalte auch keine Gewähr übernehmen. Für die Inhalte der verlinkten
        Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten
        verantwortlich. Die verlinkten Seiten wurden zum Zeitpunkt der
        Verlinkung auf mögliche Rechtsverstöße überprüft. Rechtswidrige Inhalte
        waren zum Zeitpunkt der Verlinkung nicht erkennbar. Eine permanente
        inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete
        Anhaltspunkte einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden
        von Rechtsverletzungen werden wir derartige Links umgehend entfernen.
      </Text>

      <Title mt="md" order={5}>
        Urheberrecht
      </Title>

      <Text>
        Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen
        Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung,
        Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der
        Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des
        jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite
        sind nur für den privaten, nicht kommerziellen Gebrauch gestattet.
        Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden,
        werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte
        Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine
        Urheberrechtsverletzung aufmerksam werden, bitten wir um einen
        entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden
        wir derartige Inhalte umgehend entfernen.
      </Text>
    </>
  );
}

export { Imprint };
